var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63e40189-22a9-4a6f-bf60-dbc74d42203e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.86;}\n\t.st1{fill:#1D4927;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-9e95af51-e85b-43e9-9f16-5b8e26493ebe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-39eabdba-9084-4a1d-a5a7-1d4ebbc50558",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,13.9c0.4-0.1,0.7-0.2,1-0.6c0.2-0.4,0.2-0.8-0.1-1.1c-0.3-0.4-0.7-0.7-1.1-1.1C7.8,9.9,6.6,8.8,5.5,7.7 c-0.2-0.2-0.1-0.2,0-0.3C7,5.9,8.4,4.5,9.8,3.1c0.3-0.3,0.5-0.8,0.3-1.3C9.9,1,8.9,0.9,8.3,1.5C7.6,2.2,6.9,2.9,6.2,3.6 c-1,1-1.9,2-2.9,3c-0.6,0.6-0.6,1.2,0,1.9c1.7,1.7,3.4,3.4,5.1,5.1C8.5,13.7,8.8,13.9,9.1,13.9L9.1,13.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.ba7431ac23b572a903ff074870c7283a.svg";
export { ForwardRef as ReactComponent };